(function () {
  const block = {
    $blocks: document.querySelectorAll('.accolades'),
    init() {
      if (this.$blocks.length) {

      }
    }
  };

  block.init();
})();

